import CustomerRoutes from "../../apiRoutes/CustomerRoutes";
import { api } from "../ConsumeApiController";

/*
|--------------------------------------------------------------------------
| PAY ORDER
|--------------------------------------------------------------------------
| EN - Calls the API to pay the order using the user's wallet balance.
| ES - Llama a la API para pagar el pedido usando el saldo de la billetera.
*/
export async function payOrder(orderId,currency='USD') {
    try
    {
        const url = CustomerRoutes.Payments.order; //'/client/subscriptions/pay-order';
        const response = await api.post(
            url,
            {
                order_id: orderId,
                gateway_id:'WEB',
                moneda: currency
            }
        );
        return response;
    }
    catch(error)
    {
        return { success: false, message: error.message };
    }
}


/**
 * Paga múltiples pedidos usando el saldo de la Wallet.
 * @param {Array} orderIds - Ejemplo: [101, 102, 105]
 */
export const payMultipleOrders = async (orderIds) => {
    try {
        const response = await api.post(CustomerRoutes.Payments.multipleOrders, {
            order_ids: orderIds
        });
        return response; // { success: true, data: [...] }
    } catch (error) {
        console.error("Error paying multiple orders", error);
        return { 
            success: false, 
            message: error.response?.data?.message || 'Error al procesar el pago.' 
        };
    }
};

export async function payTransactionGroup(){}